// extracted by mini-css-extract-plugin
module.exports = {"courseModesLeftPanel":"styles_courseModesLeftPanel__QVyKC"};